import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Fab,
  Paper,
  TextField,
  Avatar,
  IconButton,
  Typography,
} from '@mui/material';
import {
  SmartToy as BotIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import chatbotMini from '../assets/images/Chatbot_Mini.png';

const FloatingChatBot = () => {
  const [open, setOpen] = useState(false);
  const [question, setQuestion] = useState('');
  const navigate = useNavigate();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setQuestion('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (question.trim()) {
      // Store the question in sessionStorage to pass it to the chatbot
      sessionStorage.setItem('pendingQuestion', question.trim());
      navigate('/insights-engine');
      handleClose();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <>
      {/* Floating Button */}
      <Fab
        color="primary"
        aria-label="chat"
        onClick={handleOpen}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          width: 56,
          height: 56,
          backgroundColor: '#ffffffff',
          boxShadow: '0 4px 12px rgba(0, 125, 195, 0.4)',
          '&:hover': {
            backgroundColor: '#abbac3ff',
            boxShadow: '0 6px 16px rgba(160, 178, 189, 0.5)',
          },
          zIndex: 1000,
        }}
      >
      <img
        src={chatbotMini}
        alt="Chat Bot"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
        }}
      />
      </Fab>

      {/* Popup Box */}
      {open && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 100,
            right: 24,
            zIndex: 1001,
            animation: 'slideUp 0.3s ease-out',
            '@keyframes slideUp': {
              from: {
                opacity: 0,
                transform: 'translateY(20px)',
              },
              to: {
                opacity: 1,
                transform: 'translateY(0)',
              },
            },
          }}
        >
          <Paper
            elevation={8}
            sx={{
              width: 360,
              borderRadius: '20px',
              overflow: 'hidden',
              position: 'relative',
              background: 'linear-gradient(135deg, #00A896 0%, #007DC3 50%, #6A4C93 100%)',
              boxShadow: '0 8px 24px rgba(0, 0, 0, 0.2)',
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={handleClose}
              sx={{
                position: 'absolute',
                top: 8,
                right: 8,
                color: '#fff',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.3)',
                },
                zIndex: 1,
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            {/* Avatar */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                mt: 3,
                mb: 1,
              }}
            >
              <Avatar
                sx={{
                  width: 65,
                  height: 65,
                  backgroundColor: '#fff',
                  border: '3px solid rgba(255, 255, 255, 0.3)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                }}
              >
                <img
                  src={chatbotMini}
                  alt="Chat Bot"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }}
                />
              </Avatar>
            </Box>


            {/* Text Prompt */}
            <Box
              sx={{
                textAlign: 'center',
                mb: 2,
                px: 3,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: '18px',
                  fontFamily: 'Montserrat, sans-serif',
                }}
              >
                How can I assist you today?
              </Typography>
            </Box>

            {/* Input Field */}
            <Box
              component="form"
              onSubmit={handleSubmit}
              sx={{
                px: 3,
                pb: 3,
              }}
            >
              <TextField
                fullWidth
                placeholder="Type something..."
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
                onKeyPress={handleKeyPress}
                autoFocus
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '12px',
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '12px',
                    '& fieldset': {
                      border: 'none',
                    },
                    '&:hover fieldset': {
                      border: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      border: '2px solid #007DC3',
                    },
                  },
                  '& .MuiInputBase-input': {
                    padding: '14px 16px',
                    fontSize: '15px',
                    fontFamily: 'Montserrat, sans-serif',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    color: '#999',
                    opacity: 1,
                  },
                }}
              />
            </Box>

            {/* Pointer/Triangle */}
            <Box
              sx={{
                position: 'absolute',
                bottom: -12,
                right: 40,
                width: 0,
                height: 0,
                borderLeft: '12px solid transparent',
                borderRight: '12px solid transparent',
                borderTop: '12px solid #6A4C93',
              }}
            />
          </Paper>
        </Box>
      )}
    </>
  );
};

export default FloatingChatBot;

